module.exports = __webpack_public_path__ + "static/media/Easy_Colour.5066ef9c.png";